(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
          

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hv-sell-builder"]) return;
  try {
    
(()=>{
const root=document.getElementById('hv-sell-preview'); if(!root)return;
const $=s=>root.querySelector(s),esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
let mode='single',list=null,cards=[],cursor=null,searchController,searchVersion=0,timer,busy=false,credential;
let pilotKey='';
const designCards=[{"id":"290","name":"Blastoise","rarity":"Rare Holo","set_code":"BASE1","set_name":"Base","game_code":"POKEMON","image_url":"https://images.pokemontcg.io/base1/2_hires.png","collector_number":"2","maximum_quantity":999},{"id":"400","name":"Charizard","rarity":"Rare Holo","set_code":"BASE1","set_name":"Base","game_code":"POKEMON","image_url":"https://images.pokemontcg.io/base1/4_hires.png","collector_number":"4","maximum_quantity":999},{"id":"5692","name":"Pikachu","rarity":"Common","set_code":"BASE1","set_name":"Base","game_code":"POKEMON","image_url":"https://images.pokemontcg.io/base1/58_hires.png","collector_number":"58","maximum_quantity":999}];
const imageDialog=document.createElement('dialog');
imageDialog.className='hv-image-dialog';
imageDialog.setAttribute('aria-labelledby','hv-image-title');
imageDialog.innerHTML='<div class="hv-image-heading"><h2 id="hv-image-title">Card image</h2><button type="button" class="hv-image-close" aria-label="Close enlarged image" autofocus>Close ×</button></div><img class="hv-enlarged-image" alt=""><p class="hv-image-error" hidden>Image unavailable</p>';
root.append(imageDialog);
imageDialog.querySelector('.hv-image-close').onclick=()=>imageDialog.close();
imageDialog.addEventListener('click',e=>{if(e.target===imageDialog){const r=imageDialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)imageDialog.close();}});
root.addEventListener('click',e=>{
 const trigger=e.target.closest('.hv-image-open');if(!trigger)return;
 const source=trigger.querySelector('img');if(!source||source.hidden)return;
 const image=imageDialog.querySelector('img');image.hidden=false;imageDialog.querySelector('.hv-image-error').hidden=true;
 image.onerror=()=>{image.hidden=true;imageDialog.querySelector('.hv-image-error').hidden=false;};
 image.src=source.src;image.alt=source.alt;imageDialog.querySelector('h2').textContent=source.alt;imageDialog.showModal();
});
$('#hv-lock-page').onclick=()=>{pilotKey='';root.setAttribute('data-locked','true');$('#hv-pilot-key').value='';$('#hv-gate-error').textContent='';$('#hv-pilot-key').focus();};
const storageKey=()=>`hv-sell-guest:${root.dataset.api}`;
try {credential=JSON.parse(sessionStorage.getItem(storageKey()));}catch{}
const saveCredential=()=>{try{sessionStorage.setItem(storageKey(),JSON.stringify(credential));}catch{}};
function newCredential(){credential={token:Array.from(crypto.getRandomValues(new Uint8Array(32)),b=>b.toString(16).padStart(2,'0')).join('')};saveCredential();}
if(!credential?.token)newCredential();
async function api(action,data={},signal){
 if(!pilotKey){$('.hv-connection').open=true;$('#hv-pilot-key').focus();throw Error('Connect to private staging above before saving or submitting a list.');}
 const response=await fetch(root.dataset.api,{method:'POST',headers:{'Content-Type':'application/json','x-sell-token':credential.token,...(pilotKey?{'x-pilot-key':pilotKey}:{})},body:JSON.stringify({action,data}),signal});
 let result;try{result=await response.json();}catch{throw Error('The server could not respond. Please retry.');}
 if(!response.ok)throw Error(result.error||'Could not save changes. Please retry.');return result;
}
const panel=id=>{for(const p of ['hv-builder','hv-manual-panel','hv-review-panel','hv-success'])$('#'+p).hidden=p!==id;$('#hv-mobile-list').hidden=id!=='hv-builder';};
const status=text=>$('#hv-feedback').textContent=text;
function detailsFields(kind){return kind==='graded'?'<div class="hv-fields"><label>Grader<select name="grading_company"><option>PSA</option><option>CGC</option><option>BGS</option><option>SGC</option><option>Other</option></select></label><label>Grade<input name="grade" required maxlength="100" placeholder="e.g. 10"></label></div><label>Certification number<input name="certification_number" required maxlength="100"></label>':`<div class="hv-fields"><label>Condition<select name="reported_condition" required><option value="">Select condition</option>${(kind==='sealed'?['Sealed','Packaging damage','Other / unsure']:['Near Mint','Lightly Played','Moderately Played','Heavily Played','Damaged','Unsure']).map(x=>`<option>${x}</option>`).join('')}</select></label><label>Language<input name="reported_language" maxlength="100" placeholder="If known"></label></div>${kind==='single'?'<div class="hv-fields"><label>Finish<input name="reported_finish" maxlength="100" placeholder="e.g. holo, if known"></label><label>Edition<input name="reported_edition" maxlength="100" placeholder="e.g. first edition"></label></div>':''}`;}
function drawCards(){
 $('#hv-results').innerHTML=mode==='sealed'?'<div class="hv-sealed-empty"><h3>Have sealed Pokémon products?</h3><p>Add the product name and packaging details for staff review.</p></div>':cards.map(c=>`<article class="hv-product" data-id="${esc(c.id)}"><button type="button" class="hv-art hv-image-open" aria-label="Enlarge ${esc(c.name)} image"><img src="${esc(safeImage(c.image_url))}" alt="${esc(c.name)} — ${esc(c.set_name)} #${esc(c.collector_number)}" width="245" height="342" loading="lazy" decoding="async"><span class="hv-image-fallback" hidden>Image unavailable</span></button><form class="hv-card-form"><h3>${esc(c.name)}</h3><div class="hv-set">${esc(c.set_name)}<br> #${esc(c.collector_number)} · Pokémon</div><p class="hv-rarity">${esc(c.rarity)}</p>${detailsFields(mode)}${mode==='single'?`<label>Quantity<select name="quantity">${Array.from({length:Math.min(10,c.maximum_quantity)},(_,n)=>`<option>${n+1}</option>`).join('')}</select></label>`:'<p class="hv-meta">One slab per entry</p>'}<button class="hv-primary hv-add" type="submit" ${busy?'disabled':''}>Add to sell list ＋</button></form></article>`).join('');
 for(const img of root.querySelectorAll('.hv-art img'))img.onerror=()=>{img.hidden=true;img.nextElementSibling.hidden=false;};
}
function safeImage(url){try{const u=new URL(url);return u.protocol==='https:'&&['images.pokemontcg.io','images.scrydex.com'].includes(u.hostname)?u.href:'';}catch{return '';}}
async function search(more=false){
 searchController?.abort();searchController=new AbortController();const version=++searchVersion;
 $('#hv-search-area').hidden=mode==='sealed';$('#hv-more').hidden=true;
 if(mode==='sealed'){drawCards();$('#hv-result-count').textContent='Manual sealed-product entries';return;}
 if(!pilotKey){cards=designCards.filter(c=>c.name.toLowerCase().includes($('#hv-search').value.toLowerCase()));drawCards();$('#hv-result-count').textContent='Design preview · 3 sample cards · Connect above to test saved lists';return;}
 if(!more){cards=[];cursor=null;drawCards();}$('#hv-result-count').textContent='Searching…';
 try{const response=await api('catalog',{query:$('#hv-search').value,set:$('#hv-set').value,rarity:$('#hv-rarity').value,cursor,limit:24},searchController.signal);
 if(version!==searchVersion)return;
 const moreAvailable=response.cards.length>24,chunk=response.cards.slice(0,24);cards.push(...chunk);
 cursor=chunk.length?{name:chunk.at(-1).name,id:chunk.at(-1).id}:null;
 drawCards();$('#hv-result-count').textContent=cards.length?`${cards.length} cards shown · Name A–Z`:'No cards match. Try another search or add your item manually.';$('#hv-more').hidden=!moreAvailable;
 }catch(e){if(e.name!=='AbortError'){$('#hv-result-count').textContent='Catalog unavailable.';$('#hv-error').textContent=e.message;if(root.hasAttribute('data-locked'))$('#hv-gate-error').textContent=e.message==='Pilot access required'?'That password was not accepted. Please try again.':'Could not unlock the preview. Please check your password and connection.';}}
}
function itemDetail(i){return [i.reported_condition,i.reported_finish,i.reported_language,i.reported_edition,i.grading_company,i.grade,i.certification_number&&`Cert ${i.certification_number}`].filter(Boolean).join(' · ');}
function renderList(){
 const items=list?.items||[],total=items.reduce((n,i)=>n+i.quantity,0);$('#hv-count').textContent=total;$('#hv-mobile-list').textContent=`My sell list · ${total}`;
 $('#hv-list-meta').textContent=items.length?`${total} items · ${items.length} entries`:'Ready when you are';
 $('#hv-items').innerHTML=items.length?items.map(i=>`<div class="hv-item"><strong>${esc(i.item_snapshot.name)}</strong><small>${esc(i.item_snapshot.set_name)} · ${esc(i.item_type)}</small><small>${esc(itemDetail(i))}</small><div class="hv-item-controls">${i.item_type==='graded'?'<span>1 slab</span>':`<button data-adjust="${i.id}" data-delta="-1" aria-label="Decrease ${esc(i.item_snapshot.name)} quantity">−</button><span>${i.quantity}</span><button data-adjust="${i.id}" data-delta="1" aria-label="Increase ${esc(i.item_snapshot.name)} quantity">+</button>`}<button data-remove="${i.id}" class="hv-remove">Remove</button></div></div>`).join(''):'<div class="hv-empty">Your collection starts here.<br>Add a card to build your list.</div>';
 $('#hv-review').disabled=!items.length||busy;
 if(list?.status==='submitted'){panel('hv-success');$('#hv-confirmation').textContent=`${total} ${total===1?'item':'items'} across ${items.length} ${items.length===1?'entry':'entries'} saved successfully.`;$('#hv-reference').textContent=list.id;$('#hv-submitted-items').innerHTML=items.map(i=>`<div class="hv-item"><strong>${esc(i.item_snapshot.name)} × ${i.quantity}</strong><small>${esc(i.item_snapshot.set_name)} · ${esc(itemDetail(i))}</small></div>`).join('');$('#hv-success-title').focus();}
}
$('#hv-copy-reference').onclick=async()=>{try{await navigator.clipboard.writeText(list.id);$('#hv-copy-status').textContent='Reference copied.';}catch{$('#hv-copy-status').textContent='Select the reference above to copy it, or save a copy of your list.';}};
$('#hv-download').onclick=()=>{
 if(list?.status!=='submitted')return;
 const lines=['Hobby Vault — sell-list receipt','Reference: '+list.id,'Submitted: '+(list.submitted_at||''),'',...list.items.flatMap(i=>[i.item_snapshot.name+' × '+i.quantity,[i.item_snapshot.set_name,i.item_snapshot.collector_number,itemDetail(i)].filter(Boolean).join(' · '),i.seller_notes||'','']),'No automated email has been sent. Offers are subject to staff review and inspection.'];
 const url=URL.createObjectURL(new Blob([lines.join('\n')],{type:'text/plain;charset=utf-8'}));const link=document.createElement('a');link.href=url;link.download='hobby-vault-sell-list-'+list.id+'.txt';document.body.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),60000);
};
const retryKeys=new Map();
async function mutate(action,data){
 if(busy)return;busy=true;$('#hv-error').textContent='';root.setAttribute('aria-busy','true');
 root.querySelectorAll('button').forEach(b=>b.disabled=true);
 try{
  if(!list){list=await api('create');credential.id=list.id;saveCredential();}
  const payload={...data,list_id:list.id};const signature=JSON.stringify([action,payload]);
  const request_id=retryKeys.get(signature)||crypto.randomUUID();retryKeys.set(signature,request_id);
  list=await api(action,{...payload,request_id});retryKeys.delete(signature);
  renderList();status(action==='submit'?'Your list was saved successfully.':'Sell list saved.');return true;
 }catch(e){$('#hv-error').textContent=e.message;if(root.hasAttribute('data-locked'))$('#hv-gate-error').textContent=e.message==='Pilot access required'?'That password was not accepted. Please try again.':'Could not unlock the preview. Please check your password and connection.';return false;}
 finally{busy=false;root.removeAttribute('aria-busy');root.querySelectorAll('button').forEach(b=>b.disabled=false);$('#hv-review').disabled=!list?.items?.length;}
}
root.addEventListener('submit',async e=>{
 e.preventDefault();const form=e.target;if(!form.reportValidity()||busy)return;const data=Object.fromEntries(new FormData(form));
 if(form.id==='hv-connection-form'){
  const remoteSelected=$('#hv-connection-mode').value==='staging';
  const enteredKey=$('#hv-pilot-key').value.trim();
  if(remoteSelected&&!/^[\x21-\x7e]+$/.test(enteredKey)){
   $('#hv-error').textContent='The pilot key must contain only standard keyboard letters, numbers, or symbols, with no spaces or line breaks. Paste only the key value. If your Supabase key contains other characters, replace it there first, then enter the same new key here.';
   $('#hv-gate-error').textContent='Enter the preview password using standard keyboard characters.';status('Not connected. Check the pilot key.');$('#hv-pilot-key').focus();return;
  }
  searchController?.abort();searchVersion++;clearTimeout(timer);
  root.dataset.api=$('#hv-connection-mode').value==='staging'?'https://vephdnlnoppcxnsfmjam.supabase.co/functions/v1/hv-sell-pilot':'/api';
  const remote=$('#hv-connection-mode').value==='staging';
  $('#hv-environment').textContent=remote?'SUPABASE STAGING · NO EMAILS SENT':'LOCAL TEST · NO EMAILS SENT';
  $('#hv-test-notice').textContent=remote?'Staging test: use fictional contact details. This saves to Supabase staging and does not send notifications.':'Local test: use fictional contact details. This saves a test request locally; it does not notify Hobby Vault.';
  $('#hv-success-test').textContent=remote?'Saved in Supabase staging. No email or staff notification was sent.':'This local test has not sent an email or reached store staff.';
  pilotKey=remoteSelected?enteredKey:'';$('#hv-pilot-key').value='';list=null;retryKeys.clear();credential=null;
  cards=[];cursor=null;drawCards();$('#hv-result-count').textContent='Connecting…';$('#hv-more').hidden=true;
  try{credential=JSON.parse(sessionStorage.getItem(storageKey()));}catch{}
  if(!credential?.token)newCredential();
  $('#hv-set').innerHTML='<option value="">All sets</option>';$('#hv-rarity').innerHTML='<option value="">All rarities</option>';
  $('#hv-error').textContent='';panel('hv-builder');await start();return;
 }
 if(form.matches('.hv-card-form')){data.catalog_id=form.closest('[data-id]').dataset.id;data.item_type=mode;data.quantity=mode==='graded'?1:Number(data.quantity);await mutate('add',data);}
 else if(form.id==='hv-manual-form'){data.item_type=mode;data.quantity=mode==='graded'?1:Number(data.quantity);if(await mutate('add',data)){form.reset();panel('hv-builder');}}
 else if(form.id==='hv-submit-form')await mutate('submit',data);
});
root.addEventListener('click',async e=>{
 const tab=e.target.closest('[data-tab]');if(tab&&!busy){mode=tab.dataset.tab;root.querySelectorAll('[data-tab]').forEach(t=>t.setAttribute('aria-pressed',t===tab));search();}
 const remove=e.target.closest('[data-remove]');if(remove)await mutate('remove',{item_id:remove.dataset.remove});
 const adjust=e.target.closest('[data-adjust]');if(adjust){const item=list.items.find(i=>i.id===adjust.dataset.adjust);await mutate('quantity',{item_id:item.id,quantity:Math.max(1,item.quantity+Number(adjust.dataset.delta))});}
});
$('#hv-search').oninput=()=>{clearTimeout(timer);timer=setTimeout(()=>search(),250);};
$('#hv-set').onchange=$('#hv-rarity').onchange=()=>search();$('#hv-more').onclick=()=>search(true);
$('#hv-manual').onclick=()=>{$('#hv-manual-details').innerHTML=detailsFields(mode);const qty=$('#hv-manual-form [name="quantity"]');qty.value=1;qty.readOnly=mode==='graded';panel('hv-manual-panel');$('#hv-manual-form [name="name"]').focus();};
$('#hv-manual-cancel').onclick=$('#hv-back').onclick=()=>panel('hv-builder');
$('#hv-review').onclick=()=>{$('#hv-review-lines').innerHTML=list.items.map(i=>`<div class="hv-item"><strong>${esc(i.item_snapshot.name)} × ${i.quantity}</strong><small>${esc(itemDetail(i))}</small></div>`).join('');panel('hv-review-panel');$('#hv-submit-form [name="seller_name"]').focus();};
$('#hv-mobile-list').onclick=()=>$('.hv-summary').scrollIntoView({behavior:'smooth',block:'start'});
$('#hv-new').onclick=()=>{newCredential();list=null;retryKeys.clear();panel('hv-builder');renderList();status('New list started.');};
async function start(){
 renderList();
 try{const filters=await api('filters');root.removeAttribute('data-locked');$('#hv-gate-error').textContent='';status('Private preview · no emails sent.');$('.hv-main h1').setAttribute('tabindex','-1');$('.hv-main h1').focus();for(const [id,values] of [['hv-set',filters.sets],['hv-rarity',filters.rarities]])$('#'+id).insertAdjacentHTML('beforeend',values.filter(Boolean).map(v=>`<option value="${esc(v)}">${esc(v)}</option>`).join(''));await search();
 if(credential.id){list=await api('get',{list_id:credential.id});renderList();}}
 catch(e){$('#hv-error').textContent=e.message;if(root.hasAttribute('data-locked'))$('#hv-gate-error').textContent=e.message==='Pilot access required'?'That password was not accepted. Please try again.':'Could not unlock the preview. Please check your password and connection.';}
}
renderList();
const headerOffset=()=>{const heads=[...document.querySelectorAll('header, .sticky-header, .header-sticky')];const bottom=heads.reduce((n,h)=>{const r=h.getBoundingClientRect(),p=getComputedStyle(h).position;return (p==='fixed'||p==='sticky')&&r.bottom>0&&r.top<100?Math.max(n,r.bottom):n;},0);root.style.setProperty('--hv-sticky-top',Math.ceil(bottom+20)+'px');};
headerOffset();window.addEventListener('resize',headerOffset,{passive:true});window.addEventListener('scroll',headerOffset,{passive:true});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
           if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');			  
                  initButtons();
                  initButtonsCompare();
              }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 3000px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
